import React from 'react'
import './GPMS_hero.css'
// import portImage from "./ImagesNew/gpms_hero.jpg";
function GPMS_hero () {
  return (
    // <div className="gpms-hero-top-section">

    //   <section className="gpms-hero-section">

    //     <div className="gpms-hero-left px-5">

    //       <h1 className="gpms-hero-title">
    //         <span>Global Port Management System</span>
    //       </h1>

    //       <p className="gpms-hero-desc fw-bold text-justify">
    //         Global Port Management System (GPMS) is a powerful operational intelligence platform designed to unify complex port data into a single, actionable system.
    //       </p>

    //       <div className="gpms-hero-buttons">
    //         <button className="gpms-hero-demo-btn">Book Live Demo</button>
    //         <button className="gpms-hero-video-btn gpms-hero-demo-btn">Talk to Expert</button>
    //       </div>

    //     </div>

    //     <div className="gpms-hero-right">
    //         <div className="gpms-hero-image-wrapper">
    //           <div className="gpms-hero-image-bg">
    //             <img
    //             src="ImagesNew/gpms_hero.jpg"
    //             alt="tpms_img"
    //             className="gpms-hero-img"
    //             />
    //             </div>
    //         </div>
    //     </div>

    //   </section>

    // </div>

    <section className='gpms-hero'>
      <div className='gpms-hero__container'>
        {/* LEFT CONTENT */}
        <div className='gpms-hero__content'>
          <h1 className='gpms-hero__title'>
            Global Port Management System <span>(GPMS)</span>
          </h1>

          {/* <h2 className='gpms-hero__subtitle'>
            Intelligent Port Operations Through Data, Vision &amp; Predictive
            Analytics
          </h2>

          <p className='gpms-hero__tagline'>
            One Intelligent Platform. Complete Port Visibility. Smarter
            Decisions.
          </p> */}

          <p className='gpms-hero__text'>
            Transform complex port data into actionable intelligence with <strong>Global
            Port Management System (GPMS)</strong>, an advanced port analytics and
            decision-support platform developed by <strong>Global Suntec Solutions</strong>.
          </p>

          <p className='gpms-hero__text'>
            Powered by Qlik analytics and enhanced with Artificial Intelligence,
            GPMS connects multiple operational systems, including Navis,
            Container Management Systems (CMS), gate systems, and enterprise
            databases, to provide a unified view of port and terminal
            operations.
          </p>

          <p className='gpms-hero__text'>
            By combining live operational dashboards, historical performance
            analytics, AI-powered vehicle and container identification, and
            predictive intelligence, GPMS enables port operators to identify
            bottlenecks, anticipate delays, optimize resource utilization, and
            make informed decisions.
          </p>

          <p className='gpms-hero__text gpms-hero__text--strong'>
            Take control of your port operations with intelligent, data-driven
            insights.
          </p>

          <div className='gpms-hero__actions'>
            <a href='#demo' className='gpms-btn gpms-btn--primary'>
              Request a Demo
            </a>
            <a href='#capabilities' className='gpms-btn gpms-btn--outline'>
              Explore GPMS Capabilities
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className='gpms-hero__media'>
          <div className='gpms-hero__frame'>
            <img
              src='/ImagesNew/gpms_hero.jpg'
              alt='Aerial view of a container port with cranes and stacked containers'
              className='gpms-hero__image'
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default GPMS_hero
